var _rect, _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMetaTermsBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 6007,
    viewBox: "0 0 1920 6007",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2797_1704)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 6007,
    fill: "#020202"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter0_f_2797_1704)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1456.5 252.997C1852 -172.003 2073.29 297.608 1713.5 605.497C1467.99 715.052 1832.03 1034.14 1713.5 1022.5C1563.62 871.612 1643.5 970.615 1713.5 956.333C1011.5 696.998 632.427 713.065 810 730.499C1152.87 749.905 1016.14 -17.2923 1456.5 252.997Z",
    fill: "url(#paint0_linear_2797_1704)",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter1_f_2797_1704)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.434 -10.9202C-12.0668 -506.92 -88.1799 65.532 224.366 421.281C451.883 564.508 710.513 450.23 829.497 455.501C999.236 327.366 1547.27 360.052 1480 336C1322.31 279.615 1222.75 205.896 1044.5 198C940.748 178.889 954.866 -165.719 414.434 -10.9202Z",
    fill: "url(#paint1_linear_2797_1704)",
    fillOpacity: 0.8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2797_1704)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2797_1704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1608.86 5645.7C2238.5 5301.41 1877.77 5760.62 1925 5975.91C1693 6079.44 996.561 6141.31 884.553 6130.31C742.925 5987.73 818.411 6081.28 884.554 6067.79C1039.61 6036.15 1069.7 5674.94 1237.5 5691.41C1393.07 5706.68 1508.34 5742.66 1608.86 5645.7Z",
    fill: "url(#paint2_linear_2797_1704)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2797_1704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.891 5668.09C-127.502 5861.78 -293.388 5777.45 1.95754 6113.62C216.954 6248.96 201.361 5995.71 313.797 6000.69C474.195 5879.61 912.208 6181.7 848.644 6158.98C699.632 6105.69 1095.05 5693.95 926.606 5686.49C828.567 5668.43 577.916 5532.93 336.891 5668.09Z",
    fill: "url(#paint3_linear_2797_1704)",
    fillOpacity: 0.8
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2797_1704",
    x: 586.515,
    y: -96.8379,
    width: 1488.67,
    height: 1299.65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_2797_1704"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2797_1704",
    x: -146.703,
    y: -384.475,
    width: 1812.39,
    height: 1058.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_2797_1704"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2797_1704",
    x: 624.217,
    y: 5341.68,
    width: 1541.43,
    height: 969.887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_2797_1704"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2797_1704",
    x: -345.736,
    y: 5408.75,
    width: 1514.96,
    height: 951.449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_2797_1704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2797_1704",
    x1: 937.2,
    y1: 548.754,
    x2: 1705.94,
    y2: -172.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A660FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2797_1704",
    x1: 1051.86,
    y1: 578.79,
    x2: 365.763,
    y2: -415.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62FFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A660FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2797_1704",
    x1: 830.336,
    y1: 6026.22,
    x2: 1813.02,
    y2: 5478.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A660FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2797_1704",
    x1: 939.271,
    y1: 6225.31,
    x2: 290.936,
    y2: 5286.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.750625,
    stopColor: "#A660FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2797_1704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 6007,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2797_1704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 589,
    fill: "white",
    transform: "translate(0 5417.91)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaTermsBg);
export default __webpack_public_path__ + "static/media/meta-terms-bg.7c52acea853eb45825ad5baeefaeb4bd.svg";
export { ForwardRef as ReactComponent };